import { gql } from '@apollo/client';

export const INVOICE = gql`
  query Invoice($id: Int!) {
    invoice(id: $id) {
      id
      invoiceNumber
      organizationId
      organizationName
      created
      sent
      formattedAddress
      email
      dueDate
      pdfFileId
      excelFileId
      pdfFile {
        externalKey
      }
      excelFile {
        externalKey
      }
      status
      periodFrom
      periodTo
      currencyCode
      type
      statusUpdates {
        id
        oldStatus
        newStatus
      }
      exportStatus
      exported
    }
  }
`;

export const INVOICES = gql`
  query Invoices($data: InvoicesRequestParams!) {
    invoices(data: $data) {
      results {
        id
        invoiceNumber
        periodTo
        periodFrom
        organizationName
        status
        created
        exportStatus
        exported
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const APPROVE_INVOICE = gql`
  mutation ApproveInvoice($id: Int!) {
    approveInvoice(id: $id)
  }
`;

export const MARK_INVOICE_AS_PAID = gql`
  mutation MarkInvoiceAsPaid($id: Int!) {
    markInvoiceAsPaid(id: $id)
  }
`;

export const WRITE_OFF_INVOICE = gql`
  mutation WriteOffInvoice($id: Int!) {
    writeOffInvoice(id: $id)
  }
`;

export const BILLABLE_JOURNEYS = gql`
  query BillableJourneys($params: BillableJourneysRequestParams!) {
    billableJourneys(params: $params) {
      results {
        id
        journeyId
        fare
        fareCurrencyCode
        completion
        partnerInvoicingStatus
        transferCompanyInvoicingStatus
        prepaid
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const BILLABLE_JOURNEY = gql`
  query BillableJourney($id: Int!) {
    billableJourney(id: $id) {
      id
      journeyId
      created
      updated
      fare
      fareVatLevel
      fareCurrencyCode
      partnerCommission
      platformMarkup
      completion
      partnerInvoicingStatus
      platformMarkupCurrencyCode
      transferCompanyInvoicingStatus
      prepaid
      transferCompanyInvoiceStatusUpdates {
        id
        created
        oldStatus
        newStatus
      }
      partnerInvoiceStatusUpdates {
        id
        created
        oldStatus
        newStatus
      }
      associatedPartner {
        name
        id
      }
      associatedTransferCompany {
        name
        id
      }
    }
  }
`;

export const MANUAL_ADJUSTMENTS = gql`
  query ManualAdjustments($params: ManualAdjustmentsRequestParams!) {
    manualAdjustments(params: $params) {
      results {
        id
        journeyId
        journey {
          booking {
            id
          }
        }
        amount
        vatLevel
        description
        created
        createdByUser {
          id
          name
        }
        createdForOrganization {
          id
          name
        }
        type
        invoiceId
        invoice {
          type
        }
        invoiceLineId
        currency
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const UPDATE_BILLABLE_JOURNEY_PARTNER_INVOICING_STATUS = gql`
  mutation UpdateBillableJourneyPartnerInvoicingStatus($id: Int!, $status: String!) {
    updateBillableJourneyPartnerInvoicingStatus(id: $id, status: $status)
  }
`;

export const UPDATE_BILLABLE_JOURNEY_TRANSCO_INVOICING_STATUS = gql`
  mutation UpdateBillableJourneyTranscoInvoicingStatus($id: Int!, $status: String!) {
    updateBillableJourneyTranscoInvoicingStatus(id: $id, status: $status)
  }
`;

export const CREATE_MANUAL_ADJUSTMENT = gql`
  mutation CreateManualAdjustment($params: ManualAdjustmentCreateParams!) {
    createManualAdjustment(params: $params) {
      id
      journeyId
      journey {
        booking {
          id
        }
      }
      amount
      vatLevel
      description
      created
      createdByUser {
        id
        name
      }
      createdForOrganization {
        id
        name
      }
      type
      invoiceId
      invoice {
        type
      }
      invoiceLineId
      currency
    }
  }
`;

export const UPDATE_MANUAL_ADJUSTMENT = gql`
  mutation UpdateManualAdjustment($params: ManualAdjustmentUpdateParams!) {
    updateManualAdjustment(params: $params) {
      id
      journeyId
      journey {
        booking {
          id
        }
      }
      amount
      vatLevel
      description
      created
      createdByUser {
        id
        name
      }
      createdForOrganization {
        id
        name
      }
      type
      invoiceId
      invoice {
        type
      }
      invoiceLineId
      currency
    }
  }
`;

export const REMOVE_MANUAL_ADJUSTMENT = gql`
  mutation RemoveManualAdjustment($id: Int!) {
    removeManualAdjustment(id: $id)
  }
`;

export const APPROVE_INVOICES = gql`
  mutation ApproveInvoices($params: ApproveInvoicesRequestParams!) {
    approveInvoices(params: $params)
  }
`;

export const CREATE_JOURNEY_CORRECTION = gql`
  mutation CreateJourneyCorrection($params: JourneyCorrectionCreateParams!) {
    createJourneyCorrection(params: $params) {
      id
      journeyId
      created
      reason
      description
      currencyCode
      partnerInvoicingStatus
      amount
      transferCompanyInvoicingStatus
    }
  }
`;

export const JOURNEY_CORRECTIONS = gql`
  query journeyCorrections($params: JourneyCorrectionsRequestParams!) {
    journeyCorrections(params: $params) {
      results {
        id
        journeyId
        created
        reason
        description
        currencyCode
        partnerInvoicingStatus
        amount
        transferCompanyInvoicingStatus
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const UPDATE_JOURNEY_CORRECTION = gql`
  mutation UpdateJourneyCorrection($id: Int, $params: JourneyCorrectionUpdateParams!) {
    updateJourneyCorrection(id: $id, params: $params) {
      id
      journeyId
      created
      reason
      description
      currencyCode
      partnerInvoicingStatus
      amount
      transferCompanyInvoicingStatus
    }
  }
`;
